<template>
  <div class="about">
    <h1>Contact Hull Zombie BJJ</h1>
    <p>
      Hull Church of Ascension, HU5 5DN, Hull, East Yorkshire.<br />
      Message us on
      <a href="https://www.instagram.com/hullzombie.bjj/" target="_blank">Instagram</a>
      or
      <a href="https://www.facebook.com/martyn.oliver.75" target="_blank">Facebook</a>
      to get started.
    </p>
  </div>
</template>
